<template>
  <div class="cx-branded-card-collection">
      <div
            v-for="(card, i) in managementCards" :key="i">
      <branded-card v-if="!card.isMarginCard && !card.isCustomCard" 
                    class="card-large"
                    :brand="brand"
                    :theme="theme"
                    :title="card.title">
        <management-card  :brand="brand"
                          :card="card" 
                          class="mgmt-card"
                          :clientInfo="clientInfo"
                          :thresholds="thresholds">
          <template v-slot:default="slotProps">
            <management-table v-if="card.quarterly" 
                              :customData="card" 
                              :data="card.quarterly" 
                              mode="quarterly"
                              class="sml-table"
                              :name="card.name"
                              :thresholds="thresholds"
                              :year="slotProps.year" />
            <management-table v-if="card.monthly" 
                              :customData="card" 
                              :data="card.monthly" 
                              mode="monthly" 
                              class="lg-table"
                              :name="card.name"
                              :thresholds="thresholds"
                              :year="slotProps.year" />
          </template>
        </management-card>
      </branded-card>
          
      <div v-if="card.isMarginCard && card.isMarginCardSplitted">
        <branded-card :brand="brand"
                      v-for="(kpiGroup, i) in getKpiGroups" :key="i"
                      :theme="theme"
                      :title="card.verticalCards[i].title" 
                      :class="{ 'card-upper': i === 0, 'card-lower': i !== 0 }">
          <management-card  :brand="brand"
                            :card="card.verticalCards[i]" 
                            class="mgmt-card"
                            :fixHeader="true"
                            :clientInfo="clientInfo"
                            :clientLocationId="clientLocationId"
                            :thresholds="thresholds">
            <template v-slot:default="slotProps">
              <margin-kpi-group :clientLocationId="clientLocationId"
                                :kpiGroup="kpiGroup" 
                                :brand="brand"
                                :fixHeader="true"
                                :openPopup="openKpiPopup" 
                                :colorRange="thresholds"
                                :isHealingDeactivated="i === 0"
                                :year="slotProps.year"
                                :currentWave="currentWave" />
            </template>
          </management-card>
        </branded-card>
      </div>
    
      <div  v-if="card.isCustomCard">
        <branded-card :brand="brand"
                      :theme="theme"
                      :title="card.verticalCards[0].title"
                      class="card-regular">
          <management-card  :brand="brand"
                            :card="card.verticalCards[0]" 
                            class="mgmt-card"
                            :clientInfo="clientInfo"
                            :thresholds="thresholds">
            <template v-slot:default="slotProps">
              <management-table v-if="card.verticalCards[0].quarterly" 
                                :customData="card.verticalCards[0]" 
                                :data="card.verticalCards[0].quarterly"
                                mode="quarterly"
                                class="sml-table"
                                :name="card.verticalCards[0].name"
                                :thresholds="thresholds"
                                :year="slotProps.year" />
            </template>
          </management-card>
        </branded-card>
 
        <branded-card v-if="card.verticalCards[1]"
                      :brand="brand"
                      :theme="theme"
                      :title="card.verticalCards[1].title" 
                      :selectionMode="card.verticalCards[1].selectionMode"
                      class="card-regular">
          <management-card  :card="card.verticalCards[1]"
                            :brand="brand"
                            class="mgmt-card"
                            :clientInfo="clientInfo"
                            :selectionMode="card.verticalCards[1].selectionMode"
                            :thresholds="thresholds">
            <template v-slot:default="slotProps">
              <management-table v-if="card.verticalCards[1].quarterly" 
                                :customData="card.verticalCards[1]" 
                                :data="card.verticalCards[1].quarterly" 
                                mode="quarterly"
                                class="sml-table"
                                :name="card.verticalCards[1].name"
                                :thresholds="thresholds"
                                :selection="slotProps.selectedItem"
                                :year="slotProps.year" />

              <management-table v-else-if="card.verticalCards[1].monthly" 
                                :customData="card.verticalCards[1]" 
                                :data="card.verticalCards[1].monthly" 
                                mode="monthly"
                                :name="card.verticalCards[1].name"
                                :thresholds="thresholds"
                                :selection="slotProps.selectedItem"
                                :year="slotProps.year" />
            </template>
          </management-card>
        </branded-card>
      </div>
    </div>
    
    <MarginKpiPopup v-if="showKpiPopup"
                    :ColorRange="thresholds"
                    :ClientLocationId="clientLocationId"
                    :Kpi="selectedKpi"
                    :WaveName="selectedWave"
                    :Brand="brand"
                    @close="hideKpiPopup()" />
  </div>
</template>

<script>
import BrandedCard from '@/components/CX/DashboardCards/BrandedCard';
import DashboardService from "@/services/DashboardService-APP_TARGET";
import DateMixin from '@/mixins/DateMixin';
import EventBus from "@/services/EventBus";
import ManagementCard from '@/components/CX/DashboardCards/ManagementCard';
import ManagementTable from '@/components/CX/DashboardCards/ManagementTable';
import MarginKpiCard from '@/components/CX/MarginKpiCard';
import MarginKpiGroup from '@/components/CX/MarginKpiGroup.vue';
import MarginKpiMixin from '@/mixins/MarginKpiMixin';
import MarginKpiPopup from "@/components/CX/MarginKpiPopup.vue";
import MarginKpiStatusIndicator from '@/components/CX/MarginKpiStatusIndicator.vue';
import { i18n } from "@/i18n";

export default {
  mixins: [ DateMixin, MarginKpiMixin ],
 
  components: {
    BrandedCard,
    ManagementCard,
    ManagementTable,
    MarginKpiCard, MarginKpiPopup, MarginKpiGroup, MarginKpiStatusIndicator
  },

  props: {
    brand:                        { type: String,  default: 'Jaguar' },
    clientInfo:                   { type: Object,  default: undefined },
    clientLocationId:             { type: Number, required: true },
    marginKpiGroups:              { type: Array,  required: true },
    showLeadingMarginEvaluation:  { type: Boolean, default: true },
    thresholds:                   { type: Array,  required: true },
    theme:                        { type: String,  default: () => 'light' },
    title:                        { type: String,  default: '' }
  },

  data() {
    return {
      isLoading: true,
      managementCards: [],
      inControl: undefined,
      
      KpiIds: [],

      showKpiPopup: false,
      selectedKpi: null,
      selectedWave: null,
    };
  },

  mounted() {
    this.calculateCurrentWaveForHealing();

    this.loadInControlData();
    // this.loadMarginManagementData(); ... will be called in finally of loadInControlData 

    this.modifyData();

    // Hmm kay, this is hacky ... but shows the correct values ...
    let self = this;
    setTimeout(function() { self.$forceUpdate() }, 1500);

    EventBus.$on("refresh-margin-card", this.modifyData);
  },

  computed: {
    getKpiGroups() {
      return [ this.marginKpiGroups[1], this.marginKpiGroups[0]];
    }
  },

  methods: {
    openKpiPopup(kpi, wave) {
      if(kpi.SurveyWave.find(x => x.Name == wave)) {
        if (this.selectedKpi == kpi && this.selectedWave == wave) {
          this.hideKpiPopup();
        } else {
          kpi.ShowPopup = true; 
          this.selectedKpi = kpi;
          this.selectedWave = wave;
          this.showKpiPopup = true; 
        } 
      } else {
        this.hideKpiPopup();
      }
    },

    hideKpiPopup() {
      this.selectedKpi = null;
      this.selectedWave = null;
      this.showKpiPopup = false;
    },

    showLeadingMargin() {
      let counts = this.marginKpiGroups.map(x => x.SurveyWave.length);
      let count = counts.reduce((pv, cv) => pv + cv, 0);
      if (count === 0)
        return false;
      return this.showLeadingMarginEvaluation;
    },

    loadMarginManagementData() {
      this.isLoading = true;
      DashboardService.GetMarginManagementData(this.clientLocationId, this.brand)
        .then(res => {
          this.managementCards = this.initData(res.data);
        })
        .catch(error => {
          console.error("LOAD lead management failed", error)
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    loadInControlData() {
      this.isLoading = true;
      DashboardService.GetInControlData(this.clientLocationId, this.brand)
        .then(res => {
          this.inControl = res.data.InControl[0];
        })
        .catch(error => {
          console.error("LOAD InControl failed", error)
        })
        .finally(() => {
          this.loadMarginManagementData();
        });
    },

    modifyData() {
      this.marginKpiGroups.forEach(kpiGroup => {
        kpiGroup.Items.forEach(kpi => {
          this.KpiIds.push(kpi.SurveyKpiIds)
        });
      });
      
      let self = this;
      Promise.all([
        this.getKpisByYear(self.marginKpiGroups).catch(e => _), 
        this.getWaves(self.marginKpiGroups).catch(e => _)]
      ).then(() => {
        this.calculateWaveTotalResults(self.marginKpiGroups);
        this.isLoading = false;
      }).then(() => {
        self.$forceUpdate();
      });
    },

    getWaves(groups) {
      var promises = []
      groups.forEach(kpiGroup => {
        var waveIds = kpiGroup.SurveyWave.map(wave => wave.Id);
        if(waveIds.length > 0) {
          promises.push(DashboardService.GetSurveyWavesOfSameSurvey(waveIds.toString())
            .then((res) => {
            kpiGroup.Waves = res.data;
              kpiGroup.Items.forEach(kpi => {
                kpi.Waves = res.data;
              });
            })
            .catch((error) => {
              console.error(error);
            }))
        }
      })
      return Promise.all(promises)
    },
    
    getKpisByYear(groups) {
      const kpiids = this.KpiIds.filter(id => id != "");
      if(kpiids.length == 0 ) 
        return Promise.reject("kpis empty");
      //TODO: Exchange 2022 with the selected year
      return DashboardService.GetSurveyKpisByYear(this.KpiIds.toString(), i18n.locale, this.clientLocationId, 2022)
        .then(res => {
          return res.data == "" ? { data: [] } : res
        })
        .then(res => {
          res.data.forEach(kpiResult => {
            groups.forEach(kpiGroup => {
              kpiGroup.Items.forEach(kpi => {
                if( kpi.Code == kpiResult.KpiCode && kpi.GroupCode == kpiResult.KpiGroupCode) {
                  kpi.SurveyWave.push({
                    "CalculationMode": kpiResult.CalculationMode,
                    "SurveyWaveIds": kpiResult.SurveyWaveIds,
                    "Name": kpiResult.SurveyWaveName,
                    "PointsReached": kpiResult.PointsReached,
                    "PointsMax": kpiResult.PointsMax,
                    "Result": kpiResult.Result,
                    "Scenario": kpiResult.ScenarioName,
                    "KpiGroupName": kpiResult.KpiGroupName,
                    "Accomplished": kpiResult.Result == 1
                  })
                }
              })
            })
          })
        })
    },

    calculateWaveTotalResults(groups) {
      for(var groupIndex = 0; groupIndex < groups.length; groupIndex++) {
        for(var waveIndex = 0; waveIndex < groups[groupIndex].Waves.length; waveIndex ++) {
          let count = null;
          let correctKpiCounter = null;
          for (var itemIndex = 0; itemIndex < groups[groupIndex].Items.length; itemIndex++){
            if( groups[groupIndex].Items[itemIndex].Code === "Video Chat - Sophus3 2023 (monthly)") continue;
            var x = groups[groupIndex].Items[itemIndex].SurveyWave.find(y => y.Name == groups[groupIndex].Waves[waveIndex].NameShort);
            if(x) {
              count++;
              correctKpiCounter += x.Result == 1 ? 1 : 0;
            };
          };
          if(count != null) {
            groups[groupIndex].Waves[waveIndex].Result = (correctKpiCounter / count);
          } else {
            groups[groupIndex].Waves[waveIndex].Result = null
          }
        }
      }
    },

    initCategory(items, title, name, button, months, jagMargin, lrMargin) {
      if (!items)
        return;

      if (_.isEmpty(items.availableYears)) 
        items.availableYears = [];
      if (_.isEmpty(items.quarterly))
        items.quarterly = [];
      if (months && _.isEmpty(items.monthly))
        items.monthly = [];

      if (jagMargin && lrMargin) {
        let margin = this.$n(this.brand == 'Jaguar' ? jagMargin : lrMargin, { minimumFractionDigits: 1, maximumFractionDigits: 1});
        items.subtitle = `${margin}% Margin`;
      }

      items.button = button;
      items.title = title;
      items.name = name;
      items.brand = this.brand;
    },

    getQuarters(item) {
      // make sure no collection is undefined
      if (item.quarterly === undefined)
        item.quarterly = [];
      return item.quarterly;
    },

    calculateActualQuarter(data) {
      // letztes Quartal ermitteln
      let maxxes = [];
      maxxes.push(Math.max(...this.getQuarters(data.LeadManagement).map(x => x.Quarter)));
      maxxes.push(Math.max(...this.getQuarters(data.ClosedRedFlags).map(x => x.Quarter)));
      maxxes.push(Math.max(...this.getQuarters(data.ContactQuota).map(x => x.Quarter)));
      maxxes.push(Math.max(...this.getQuarters(data.NPS).map(x => x.Quarter)));
      return (maxxes.length < 1) ? undefined : Math.max(...maxxes);
    },
    
    setAllYears(data) {
      // TODO: RETAIL Marketing und Händler Performance ... evtl. auch noch dazu
      let uniqueYears = _.uniq([ 
        ...data.LeadManagement.availableYears,
        ...data.ClosedRedFlags.availableYears,
        ...data.ContactQuota.availableYears,
        ...data.NPS.availableYears ]);
      
      if (uniqueYears.length === 0) 
        uniqueYears.push(new Date().getFullYear()); 
      
      uniqueYears = _.sortedUniq(uniqueYears).reverse(); // [ 2023, 2022, 2021 ];

      data.LeadManagement.availableYears = uniqueYears;
      data.ClosedRedFlags.availableYears = uniqueYears;
      data.ContactQuota.availableYears = uniqueYears;
      data.NPS.availableYears = uniqueYears;

      return uniqueYears;
    },

    fillUpQuarterlyResults(quarterList, availYears, lastActiveQuarter, itemTemplate) {
      let actualYear = new Date().getFullYear();
      for (let j = 0; j < availYears.length; j++) {
        let maxQuarters = availYears[j] < actualYear ? 4 : lastActiveQuarter;
        for (let i = 1; i <= maxQuarters; i++) {
          const element = quarterList.find(x => x.Quarter === i && x.Year === availYears[j]);
          if (!element && availYears[j] <= actualYear) {
            let item = JSON.parse(JSON.stringify(itemTemplate));
            item.Year = availYears[j];
            item.Quarter = i;
            quarterList.push(item);
          }
        }
      }
    },

    initData(data) {
      if (!data)
        return [];

      let actualQuarter = this.calculateActualQuarter(data);
      let closedQuarter = this.getClosedQuarter();

      this.initCategory(data.LeadManagement, this.$t('Webportal.CX.LeadManagement'), 'LeadManagement', true, true, 1.5, 1.0);
      this.initCategory(data.ClosedRedFlags, `${this.$t('Webportal.CX.CustomerFirst')} ${this.$t('Webportal.Dashboard.NPS')} - ${this.$t('Webportal.CX.RedFlagClosing')}`, 'ClosedRedFlags', false, true, 0.5, 0.3);
      this.initCategory(data.ContactQuota, `${this.$t('Webportal.CX.CustomerFirst')} ${this.$t('Webportal.Dashboard.NPS')} - ${this.$t('Webportal.CX.ContactQuota')}`, 'ContactQuota', true, false, 0.8, 0.7);
      this.initCategory(data.NPS, `${this.$t('Webportal.CX.CustomerFirst')} ${this.$t('Webportal.Dashboard.NPS')} - ${this.$t('Webportal.Dashboard.NPS')}`, 'NPS', false, false, 0.5, 0.3);

      data.InControl = { 
        title: "InControl",
        height: '720px!important',
        subtitle: this.$t('Webportal.CX.EntryRequirement'),
        availableYears: this.inControl.availableYears,
        button: true,
        popupWidth: 800, 
        name: "InControl",
        brand: this.brand,
        details: this.inControl.details,
        quarterly: this.inControl.quarterly,
        monthly: this.inControl.monthly
      };
      this.initCategory(data.InControl, "InControl", "InControl", false, false, null, null);
      data.InControl.button = true;
      data.InControl.selectionMode = 'monthly';

      let availYears = this.setAllYears(data);

      // NPS auffüllen
      this.fillUpQuarterlyResults(data.NPS.quarterly, availYears, Math.min(actualQuarter, closedQuarter), 
        { FullfilledContactQuota: undefined, FullfilledNPS: undefined });
      // RF Schließung auffüllen
      this.fillUpQuarterlyResults(data.ClosedRedFlags.quarterly, availYears, Math.min(actualQuarter, closedQuarter), 
        { TotalRedFlags: 0, ClosedRedFlags: 0, CloseTime: 0 });

      let rm = { 
        title: this.$t('Webportal.CX.RetailMarketing'),
        height: '314px!important',  
        subtitle: this.marginKpiGroups[1].Name,
        availableYears: [2022],
        button: false,
        name: this.$t('Webportal.CX.RetailMarketing'),
        brand: this.brand
      };

      let dh = { 
        title: this.$t('Webportal.CX.DigitalDealerPerformance'),
        height: '614px!important',
        subtitle: this.marginKpiGroups[0].Name,
        availableYears: [2022,2023],
        button: true,
        popupWidth: 600,
        name: this.$t('Webportal.CX.DigitalDealerPerformance'),
        brand: this.brand
      };

      return [
        data.LeadManagement, 
        // { isMarginCard: true }, // old Version
        { verticalCards: [rm, dh ], isMarginCard: true, isMarginCardSplitted: true },
        { verticalCards: [data.ClosedRedFlags, data.ContactQuota], isCustomCard: true },
        { verticalCards: [data.NPS, data.InControl], isCustomCard: true }
      ].filter(item => item !== undefined);
    }
  }
};
</script>

<style scoped>
  .cx-branded-card-collection {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-gap: 1rem;
    width: calc(100% - 3rem);
  }

  .lg-margincard {
    max-width: unset !important;
  }

  .card-regular {
    height: 28.5rem; 
    margin-bottom: 1.5rem;
  }

  .card-large {
    height: 58.5rem;
  }

  .card-upper {
    margin-bottom: 1.5rem;
    height: 21.5rem;
  }

  .card-lower {
    height: 35.5rem;
  }

  .sml-table {
    height: 13.5rem;
  }
  .lg-table {
    height: 28rem;
  }
</style>
